import { render, staticRenderFns } from "./gameRender.vue?vue&type=template&id=3b657250&scoped=true&"
import script from "./gameRender.vue?vue&type=script&lang=js&"
export * from "./gameRender.vue?vue&type=script&lang=js&"
import style0 from "./gameRender.vue?vue&type=style&index=0&id=3b657250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b657250",
  null
  
)

export default component.exports